import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import API from "../api/config"; // Your API service

export const AuthContext = createContext();

export const AuthContextProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [tokenExpiry, setTokenExpiry] = useState(null);
  const navigate = useNavigate();
  const [userPermission, setUserPermission] = useState({});

    // Logout function
  const logout = useCallback(async (manualLogout = false) => {
    
    if (manualLogout) {
      try {
        const token = localStorage.getItem("access_token");
        if (token) {
          await  API.post("logout", {}, {
            headers: { Authorization: `Bearer ${token}` }
          });
        }
      } catch (error) {
        console.error("Logout error:", error);
      }
    }

    // Clear all storage
    localStorage.clear();
    sessionStorage.clear(); // Clear sessionStorage as well, to avoid confusion

    // Reset state
    setIsAuthenticated(false);
    setUser(null);
    setTokenExpiry(null);

    navigate("/", { replace: true });
  }, [navigate]);
  // Check token expiry periodically
  useEffect(() => {
    const checkTokenExpiry = () => {
      if (tokenExpiry && new Date() > tokenExpiry) {
        logout();
      }
    };
    
    const interval = setInterval(checkTokenExpiry, 60000); // Check every minute
      return () => clearInterval(interval);
    }, [logout, tokenExpiry]);

  // Check session on initial load
  const checkSession = useCallback(() => {
    const storedUser = localStorage.getItem("user");
    const storedExpiry = localStorage.getItem("expires_in");

    if (storedUser && storedExpiry) {
      const expiryDate = new Date(storedExpiry); // Parse the expiration string as Date
      if (new Date() < expiryDate) {
        setIsAuthenticated(true);
        setUser(JSON.parse(storedUser));
        setTokenExpiry(expiryDate);
      } else {
        logout();
      }
    }
  }, [logout]);

  useEffect(() => {
    checkSession();
  }, [checkSession]);
  useEffect(() => {
    if(user?.role_id !== 1){
      const fetchPermissions = async () => {
        if (user?.userid && user?.access_token) {
          try {
            const response = await API.get(`getPermissionPage?userid=${user.userid}`, {
              headers: { Authorization: `Bearer ${user.access_token}` },
            });

            let permissionData = response.data.permisiondata_info || response.data.msg || [];

            if (!Array.isArray(permissionData)) {
              permissionData = [];
            }

            const permissionsMap = {};

            permissionData.forEach((perm) => {
              permissionsMap[perm.Pagename] = {
                view: perm.permissioncat_id?.includes("1"),
                add: perm.permissioncat_id?.includes("2"),
                update: perm.permissioncat_id?.includes("3"),
                delete: perm.permissioncat_id?.includes("4"),
                download: perm.permissioncat_id?.includes("5"),
                pageId: perm.pageid,
              };
            });

            setUserPermission(permissionsMap);
          } catch (error) {
            console.error("Error fetching permissions:", error);
          }
        }
      };
      fetchPermissions();
    }
  }, [user]); // Only runs when `user` changes

  // Login function
  const login = useCallback((userData) => {
    const expiryDate = new Date(userData.expires_in); // Parse the string from backend

    setIsAuthenticated(true);
    setUser(userData);
    setTokenExpiry(expiryDate);

    // Store in localStorage
    localStorage.setItem("isAuthenticated", "true");
    localStorage.setItem("user", JSON.stringify(userData));
    localStorage.setItem("access_token", userData.access_token);
    localStorage.setItem("expires_in", userData.expires_in); // Store the string directly
    navigate("/dashboard");
  }, [navigate]);


 
  return (
    <AuthContext.Provider value={{ isAuthenticated, user, login, logout, tokenExpiry, userPermission }}>
      {children}
    </AuthContext.Provider>
  );
};
export const useAuth = () => useContext(AuthContext);
